<script setup>
import { ref, reactive, onMounted } from "vue";

import { NavBar, Dialog } from "vant";
import routers from "@/hooks/routers";
import { useStore } from "vuex";
import { send_captcha, login_mobile } from "@/api/user";
import md5 from "md5";
import { getPartnerSetting } from "@/api/partner";

const store = useStore();
const titleStatus = store.state.titleStatus;
const { linkTo, goBack } = routers();

async function sendCaptcha() {
  if (!loginInfo.agreement) {
    return Dialog.alert({
      message: "请阅读且勾选同意服务协议",
      confirmButtonColor: "#101010",
    });
  }

  if (
    !/^(?:(?:\+|00)86)?1\d{10}$/.test(loginInfo.mobile) ||
    loginInfo.isSendCaptcha
  ) {
    return;
  }

  let mobile = loginInfo.mobile;
  let action = "send_sms"; //获取当前操作动作
  let timestrap = Date.parse(new Date()) / 1000; //获取秒时间戳
  let salt = "#$@JYF0+)@!"; //加密中插入的随机码
  let md5key = eval("action+mobile+salt+timestrap+'2'"); //拼接需要加密的数据
  let sign = md5(md5key); //加密生成sign值

  let data = {
    version: 2,
    mobile,
    timestrap,
    sign,
  };

  let result = await send_captcha(data);
  console.log(result);
  if (result.data?.isSucess) {
    Dialog.alert({
      message: "发送成功",
      confirmButtonColor: "#101010",
    });

    loginInfo.isSendCaptcha = true;

    let time = 60;
    let timer = setInterval(() => {
      time--;
      loginInfo.captchaStatus = time + " s";
      if (time === 0) {
        loginInfo.captchaStatus = "重新发送";
        loginInfo.isSendCaptcha = false;
        clearInterval(timer);
      }
    }, 1000);
  } else {
    Dialog.alert({
      message: result.data.message,
      confirmButtonColor: "#101010",
    });
  }
}

function submit() {
  if (loginInfo.mobile.length < 11 || !loginInfo.captcha) return;

  if (!loginInfo.agreement) {
    return Dialog.alert({
      message: "请阅读且勾选同意服务协议",
      confirmButtonColor: "#101010",
    });
  }
  login();
}

let headImg = ref("");
/**
 * @description: 获取合作商首页配置
 * @param {*}
 * @return {*}
 */
async function getIndexConfig() {
  let sign = md5(
    `action=setting&appkey=${store.state.appkey}&item_key=homePage&partner_id=${store.state.partnerId}${store.state.secret}`
  );

  let params = {
    appkey: store.state.appkey,
    item_key: "homePage",
    partner_id: store.state.partnerId,
    sign,
  };
  let resutl = await getPartnerSetting(params);
  // console.log(resutl);
  if (resutl.status === 200 && resutl.data?.isSucess) {
    let data = JSON.parse(resutl.data.data.item_value);
    if (data.cooperationLogo.isDisabled) {
      headImg.value = data.cooperationLogo.img.length
        ? data.cooperationLogo.img[0].response.data.url
        : "";
    }
  }
}

/**
 * @description: 登录
 * @param {*}
 * @return {*}
 */
async function login() {
  let data = {
    mobile: loginInfo.mobile,
    mobilecode: loginInfo.captcha,
  };

  let result = await login_mobile(data);
  console.log(result);

  // //模拟登录成功
  // let userData = {
  //   truename: "",
  //   username: "13486328397",
  //   token: "19fa71e2e7d7cdacfdd9b5da26cc3aa7",
  // };
  // store.commit("setUserInfo", userData);
  // goBack();

  if (result.data?.isSucess) {
    let userData = result.data.data;
    store.commit("setUserInfo", userData);
    Dialog.alert({
      message: "登录成功",
      confirmButtonColor: "#101010",
    }).then(() => {
      goBack();
    });
  } else {
    Dialog.alert({
      message: result.data.message,
      confirmButtonColor: "#101010",
    });
  }
}

// 登录信息
let loginInfo = reactive({
  mobile: "",
  captcha: "",
  agreement: false,
  isSendCaptcha: false,
  captchaStatus: "获取验证码",
});

onMounted(() => {
  getIndexConfig();
});
</script>
<template>
  <div class="main">
    <NavBar
      v-if="titleStatus"
      title="登录"
      left-arrow
      fixed
      placeholder
      @click-left="goBack"
      :border="false"
    />
    <div class="logo">
      <div class="wrap">
        <img :src="headImg" alt />
      </div>
    </div>
    <div class="title">
      <div>手机快捷登录</div>
      <div>未注册的手机号将自动创建新账号</div>
    </div>
    <div class="from">
      <div class="inputWrap">
        <input
          type="number"
          placeholder="请输入您的手机号"
          v-model="loginInfo.mobile"
        />
      </div>
      <div class="inputWrap">
        <input
          type="text"
          placeholder="请输入短信验证码"
          v-model="loginInfo.captcha"
        />
        <div
          :class="[
            'yzm',
            /^(?:(?:\+|00)86)?1\d{10}$/.test(loginInfo.mobile) ? 'active' : '',
          ]"
          @click="sendCaptcha()"
        >
          {{ loginInfo.captchaStatus }}
        </div>
      </div>
      <div
        :class="[
          'submit',
          loginInfo.mobile && loginInfo.captcha ? 'active' : '',
        ]"
        @click="submit()"
      >
        登 录
      </div>
      <div class="clause">
        <div
          :class="['btn', loginInfo.agreement ? 'active' : '']"
          @click="loginInfo.agreement = !loginInfo.agreement"
        >
          <span class="iconfont icon-hook-copy"></span>
        </div>
        <div class="des">
          已仔细阅读并同意
          <span @click="linkTo('/agreement')">《白鲸鱼用户服务协议》</span>和
          <span @click="linkTo('/policy')">《白鲸鱼隐私政策》</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style></style>
<style lang="scss" scoped>
.main {
  padding: 0.2rem 0.4rem;
  .logo {
    .wrap {
      text-align: center;
      color: #555555;
      font-size: 0.12rem;
      img {
        height: 0.3rem;
        display: inline-block;
        vertical-align: bottom;
      }
    }
  }
  .title {
    margin: 0.4rem 0;
    font-size: 14px;
    color: #666;
    div:first-child {
      color: #4a4a4a;
      font-size: 18px;
      margin: 0 0 0.1rem;
      font-weight: bold;
    }
  }
  .from {
    .inputWrap {
      position: relative;
      margin: 0 0 0.2rem 0;
      border-bottom: 1px solid #f2f2f2;
      input {
        border: none;
        outline: none;
        line-height: 0.3rem;
        width: 100%;
        height: 0.3rem;
        font-size: 14px;
      }
      .yzm {
        position: absolute;
        top: 0;
        right: 0;
        color: #fff;
        padding: 0.05rem 0.2rem;
        font-size: 12px;
        background: #e1e1e1;
        border-radius: 25px;
        &.active {
          background: var(--themeColor);
        }
      }
    }
    .submit {
      color: #fff;
      background: #e1e1e1;
      text-align: center;
      line-height: 0.45rem;
      border-radius: 0.25rem;
      font-size: 14px;
      margin: 0.4rem 0 0.5rem;
      box-shadow: 0px 4px 6px 1px rgba(247, 247, 247, 0.4);
      &.active {
        background: var(--themeColor);
        box-shadow: 0px 4px 6px 1px rgba(255, 149, 52, 0.4);
      }
    }
    .clause {
      font-size: 12px;
      display: flex;
      align-items: center;
      .btn {
        border-radius: 100%;
        height: 20px;
        width: 22.5px;
        line-height: 20px;
        border: 1px solid #bbb;
        margin: 0 0.05rem 0 0;
        text-align: center;
        box-sizing: border-box;
        color: #fff;
        font-weight: bold;
        &.active {
          background: #1460ff;
          border-color: #1460ff;
        }
        span {
          font-size: 12px;
        }
      }
      .des {
        span {
          color: #2b5ffe;
        }
      }
    }
  }
}
</style>
